import React from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
import Navbar from "components/Navbar";
import "./index.scss";

const DashboardLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="main-wrapper">{children}</main>
      <ToastContainer />
    </>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default DashboardLayout;
